<template>
	<div>
		<div class="q-display-1 q-mb-md text-secondary">
			<q-icon name="far fa-user" class="q-mb-sm" /> {{ $t('user') }}
		</div>
		<div class="row gutter-xs">
			<div class="col-xs-12 col-sm-12">
				<q-input
					v-model="full_name"
					ref="full_name"
					:float-label="`${$t('name_and_last_name')}`"
					:error="$v.full_name.$error"
					@input="$v.full_name.$touch"
				/>
			</div>

			<div class="col-xs-12 col-sm-12">
				<q-field :error="email_error" :error-label="`${$t('email_not_unique')}`">
					<q-input
						v-model="email"
						ref="email"
						type="email"
						:float-label="`${$t('email')}`"
						:error="$v.email.$error"
						@input="$v.email.$touch"
						@blur="emailUnique()"
					/>
				</q-field>
			</div>
			<div class="col-xs-12 col-sm-6">
				<q-field :error="document_error" :error-label="$t('document_not_unique')">
					<q-input
						v-model="document"
						ref="document"
						:float-label="`${$t('document')}`"
						:error="$v.document.$error"
						@input="$v.document.$touch"
						@blur="documentUnique()"
					/>
				</q-field>
			</div>
			<div class="col-xs-12 col-sm-6">
				<q-select
					filter
					autofocus-filter
					v-model="profile"
					:error="$v.profile.$error"
					@input="$v.profile.$touch"
					:options="getProfileOptions()"
					ref="profile"
					:float-label="`${$t('profile')}`"
				/>
			</div>
		</div>
		<div class="row gutter-sm justify-end q-mt-lg">
			<div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
				<q-btn
					color="tertiary"
					class="full-width"
					:label="$t('back')"
					icon="far fa-chevron-left"
					@click="clearAndClose()"
				/>
			</div>

			<div class="col-xs-12 col-sm-3" :class="getOrder('save')">
				<q-btn
					color="positive"
					class="full-width"
					:label="$t('save')"
					icon="far fa-save"
					@click="saveData()"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'
export default {
	props: ['id'],
	data() {
		return {
			full_name: '',
			email: '',
			email_error: false,
			profile: null,
			document: '',
			document_error: false,
		}
	},
	computed: {
		...mapGetters({
			id_user_client_selected: 'common/id_user_client_selected',
			user_clients: 'common/user_clients',
			access_token: 'common/access_token',
		}),
		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},
	},
	methods: {
		emailUnique() {
			if (this.email) {
				let fd = new FormData()
				fd.append('email', this.email)
				fd.append('id_user', '0')

				this.$axios
					.post(`/admin_users/users/check_email_existance/`, fd, this.getHeader)
					.then((response) => {
						if (response.data.exists) {
							this.email_error = true
							this.id_user = response.data.id_user
						} else this.email_error = false
					})
					.catch((e) => {
						console.log(e)
					})
			} else this.email_error = false
		},
		getProfileOptions() {
			let obj = this.user_clients.find((obj) => {
				return obj.id === this.id_user_client_selected
			})
			if (obj) return obj.client_profiles
			else return []
		},
		getOrder(name) {
			if (name == 'cancel') {
				if (this.$q.platform.is.mobile) return 'order-last'
				else return 'order-first'
			} else if (name == 'save') {
				if (this.$q.platform.is.mobile) return 'order-first'
				else return 'order-last'
			}
		},
		saveData() {
			this.$v.$touch()
			if (!this.$v.$invalid && !this.email_error && !this.document_error) {
				const data = {
					full_name: this.full_name,
					email: this.email,
					document: this.document,
					profile: this.profile,
				}

				this.$axios
					.post(
						`presential/presential_events/${this.id}/results/register_new_user/`,
						data,
						this.getHeader
					)
					.then((response) => {
						this.$emit('closeRegisterUser')
						this.$q.notify({
							message: this.$t('save_data_success'),
							type: 'positive',
							icon: 'fal fa-exclamation-triangle',
							position: 'top',
						})
						this.clearAndClose(true)
					})
					.catch((e) => {
						console.log(e)
					})
			} else {
				this.$q.notify({
					message: this.$t('make_sure_that_all_fields_are_filled_in'),
					type: 'negative',
					icon: 'fal fa-exclamation-triangle',
					position: 'top',
				})
			}
		},
		documentUnique() {
			if (this.document) {
				let fd = new FormData()
				fd.append('document', this.document)
				fd.append('id_user', '0')

				this.$axios
					.post(`/admin_users/users/check_document_existance/`, fd, this.getHeader)
					.then((response) => {
						if (response.data.exists) {
							this.document_error = true
							this.id_user = response.data.id_user
						} else this.document_error = false
					})
					.catch((e) => {
						console.log(e)
					})
			} else this.document_error = false
		},

		clearFields() {
			this.full_name = ''
			this.email = ''
			this.profile = null
			this.document = ''
			this.email_error = false
			this.document_error = false
		},

		clearAndClose(value) {
			this.clearFields()
			this.$emit('closeRegisterUser', value)
			this.$v.$reset()
		},
	},

	validations() {
		return {
			full_name: { required },
			email: { required },
			document: { required },
			profile: { required },
		}
	},
}
</script>
